import type { BorderColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useDefaultSelectedElementDesignation } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

import ColorSelector from "./ColorSelector";

interface BorderColorModifierProps {
  onChange: (modifier: BorderColorModifierValue) => void;
}

const BorderColorModifier: React.FC<BorderColorModifierProps> = ({
  onChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  const [currentColor, setCurrentColor] = useOverridableState(
    defaultDesignation?.element.styleOverrides?.borderColorHex ?? null,
    React.useCallback(
      (color: string | null) => {
        onChange({
          type: "borderColor",
          value: color,
        });
      },
      [onChange],
    ),
  );

  return <ColorSelector value={currentColor} onChange={setCurrentColor} />;
};

export default BorderColorModifier;
